import(/* webpackMode: "eager" */ "/app/apps/frodo/src/app/global-error.tsx");
